const TOKEN_KEY = 'zashani_token';
const USER_KEY = 'zashani_user';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const getSession = () => {
    try {
        return JSON.parse(localStorage.getItem(USER_KEY));
    } catch (error) {
        return null;
    }
};

export const setSession = (user) => localStorage.setItem(USER_KEY, JSON.stringify(user));
export const clearSession = () => localStorage.removeItem(USER_KEY);
